module.exports = __webpack_public_path__ + "static/img/hot6.48c4474.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyun/hot6.jpg
// module id = b1B5
// module chunks = 1